/**
 * Session management utilities.
 *
 * Utilities for generating and managing simulation session IDs.
 *
 * @module sessionUtils
 */

/**
 * Generate a unique session ID for a simulation
 *
 * Format: `sess-{userId}-{timestamp}`
 * This matches the pattern used in the old version for consistency.
 *
 * @param userId - User ID (UUID string)
 * @returns Session ID string
 *
 * @example
 * ```typescript
 * const sessionId = generateSessionId("user-123");
 * // Returns: "sess-user-123-1234567890123"
 * ```
 */
export function generateSessionId(userId: string): string {
  const timestamp = Date.now();
  return `sess-${userId}-${timestamp}`;
}

